// Deterministic color palette for customer types
// Maps a name/id string to a consistent color via hash

export interface TypeColor {
  bg: string;
  text: string;
  border: string;
  dot: string;
}

const PALETTE: TypeColor[] = [
  { bg: '#fef3c7', text: '#b45309', border: '#fde68a', dot: '#f59e0b' }, // amber
  { bg: '#fce7f3', text: '#be185d', border: '#fbcfe8', dot: '#ec4899' }, // pink
  { bg: '#f0fdf4', text: '#15803d', border: '#bbf7d0', dot: '#22c55e' }, // green
  { bg: '#fff7ed', text: '#c2410c', border: '#fed7aa', dot: '#f97316' }, // orange
  { bg: '#ecfdf5', text: '#065f46', border: '#a7f3d0', dot: '#10b981' }, // emerald
  { bg: '#fff1f2', text: '#be123c', border: '#fecdd3', dot: '#f43f5e' }, // rose
  { bg: '#fafaf9', text: '#57534e', border: '#e7e5e4', dot: '#78716c' }, // stone
  { bg: '#ecfdf5', text: '#0f766e', border: '#99f6e4', dot: '#14b8a6' }, // teal
  { bg: '#fffbeb', text: '#92400e', border: '#fde68a', dot: '#d97706' }, // yellow-brown
  { bg: '#fdf2f8', text: '#9d174d', border: '#f9a8d4', dot: '#db2777' }, // magenta
];

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

export function getTypeColor(nameOrId: string): TypeColor {
  return PALETTE[hashString(nameOrId) % PALETTE.length];
}
